import riot from 'riot';
import events from '../src/events.js';
import { getQuestions as libGetQuestions, getAnswers as libGetAnswers, postAnswers as libPostAnswers, getResponses as libGetResponses, postResponses as libPostResponses } from '../src/lib.js';
riot.tag2('knowledge-check-deprecated', '<div class="container is-fluid has-text-centered" show="{responsesLoading}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="container is-fluid has-text-centered" show="{submitQuizLoading}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <article class="message is-warning is-large" if="{!responsesLoading && !submitQuizLoading && !responsesError && hasSubmittedResponses()}"> <div class="message-body"> Watch out! You already submitted this knowledge check so submitting it again will overwrite your previous answers! <button class="button is-warning" onclick="{tryQuizAgainClick}"> <span class="icon is-small"> <i class="fas fa-exclamation"></i> </span> <span>Try Quiz Again!</span> </button> </div> </article> <article class="message is-danger is-large" if="{responsesError}"> <div class="message-body"> Uh Oh! It looks like there was an error getting your previous answers! <button class="button is-rounded" onclick="{refreshResponsesClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> <span>Refresh!</span> </button> </div> </article> <div class="tags are-small" show="{!responsesLoading && !submitQuizLoading && selectedQuestion> -1}"> <span class="tag is-info {i==selectedQuestion?\'\':\'is-light\'}" each="{q,i in questions}">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{i}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> </div> <article class="message" each="{q,i in questions}" show="{i==selectedQuestion && !responsesLoading && !submitQuizLoading}"> <div class="message-header"> <p>{q.question}</p> </div> <div class="message-body" show="{q.type===\'fa\'}"> <textarea class="textarea" id="{selectedActivityRef}_answer_{activeStepIndex}_{q.id}" placeholder="Enter your answer here"></textarea> <div class="buttons" style="margin-top: 25px;"> <button class="button is-danger" onclick="{prevQuestion}"> <span class="icon is-small"> <i class="fas fa-chevron-left"></i> </span> <span>Back</span> </button> <button class="button is-success" onclick="{nextQuestion}"> <span>{isLastStep() ? \'Submit Quiz!\':\'Save + Next Question\'}</span> <span class="icon is-small"> <i class="fas fa-chevron-right"></i> </span> </button> </div> </div> <div class="message-body" show="{q.type===\'mc\'}"> <div class="control"> <span each="{o in q.options}"> <label class="radio"> <input type="radio" name="{selectedActivityRef}_answer_{activeStepIndex}_{q.id}" riot-value="{o}"> {o} </label><br> </span> </div> <div class="buttons" style="margin-top: 25px;"> <button class="button is-danger" onclick="{prevQuestion}"> <span class="icon is-small"> <i class="fas fa-chevron-left"></i> </span> <span>Back</span> </button> <button class="button is-success" onclick="{nextQuestion}"> <span>{isLastStep() ? \'Submit Quiz!\':\'Save + Next Question\'}</span> <span class="icon is-small"> <i class="fas fa-chevron-right"></i> </span> </button> </div> </div> <div class="message-body" show="{q.type===\'tf\'}"> <div class="control"> <label class="radio"> <input type="radio" name="{selectedActivityRef}_answer_{activeStepIndex}_{q.id}" value="true"> True </label> <br> <label class="radio"> <input type="radio" name="{selectedActivityRef}_answer_{activeStepIndex}_{q.id}" value="false"> False </label> </div> <div class="buttons" style="margin-top: 25px;"> <button class="button is-danger" onclick="{prevQuestion}"> <span class="icon is-small"> <i class="fas fa-chevron-left"></i> </span> <span>Back</span> </button> <button class="button is-success" onclick="{nextQuestion}"> <span>{isLastStep() ? \'Submit Quiz!\':\'Save + Next Question\'}</span> <span class="icon is-small"> <i class="fas fa-chevron-right"></i> </span> </button> </div> </div> </article>', '', '', function(opts) {
        var self = this;

        self.selectedQuestion = 0;
        self.activeStep = self.parent.activeStep;
        self.activeStepIndex = self.parent.activeStepIndex;
        self.selectedActivityRef = self.parent.selectedActivity.activity_ref;
        self.responsesLoading = false;
        self.submitQuizLoading = false;
        self.questions = [];
        self.answers = [];
        self.currentAnswer = {};

        self.on('mount', function() {

            getQuestions(self.parent.selectedActivity.lesson.id);
        });

        events.on('get_quiz_responses', function(data) {
            self.activeStep = data['activeStep'];
            self.selectedActivityRef = data['act_ref'];
            self.activeStepIndex = data['activeStepIndex'];

            if (data['load_responses']) {
                getResponses(self.parent.selectedActivity.activity_ref);
            } else {
                self.update();
            }

            answerId = self.selectedActivityRef + "_answer_" + self.activeStepIndex + "_" + self.selectedQuestion
            self.loadAnswerFromCache(answerId);
        });

        this.refreshResponsesClick = function(e) {
            getResponses(self.parent.selectedActivity.activity_ref);
        }.bind(this)

        this.tryQuizAgainClick = function(e) {
            self.selectedQuestion = 0;
            answerId = self.parent.selectedActivity.activity_ref + "_answer_" + self.parent.activeStepIndex + "_" + self.selectedQuestion
            self.loadAnswerFromCache(answerId);
            self.update();
        }.bind(this)

        this.hasSubmittedResponses = function() {

            if (!self.responses) {
                return false;
            }

            for (var i = 0; i < self.responses.length; i++) {
                if (self.responses[i].step == self.activeStepIndex) {
                    return true;
                }
            }

            return false;
        }.bind(this)

        this.isLastStep = function() {
            if (self.selectedQuestion === self.parent.activeStep.questions.length - 1) {
                return true;
            } else {
                return false;
            }
        }.bind(this)

        this.loadAnswerFromCache = function(answerId) {
            if (self.parent.activeStep.questions[self.selectedQuestion].type === 'fa') {
                var storedData = localStorage.getItem(answerId);
                if (storedData) {
                    cachedResponse = JSON.parse(storedData);
                    element = document.getElementById(answerId);
                    if (element) {
                        document.getElementById(answerId).value = cachedResponse['answer'];
                    } else {
                        console.log("Expected DOM element does not exist: " + answerId)
                    }
                }
            }

            else if (self.parent.activeStep.questions[self.selectedQuestion].type === 'mc' || self.parent.activeStep.questions[self.selectedQuestion].type === 'tf') {
                var storedData = localStorage.getItem(answerId);
                if (storedData) {
                    var options = document.getElementsByName(answerId);
                    cachedResponse = JSON.parse(storedData);
                    if (options) {
                        for (i = 0; i < options.length; i++) {
                            if (options[i].value == cachedResponse['answer']) {
                                options[i].checked = true
                            }
                        }
                    }
                }
            }
        }.bind(this)

        this.saveAnswerToCache = function(answerId) {

            if (self.parent.activeStep.questions[self.selectedQuestion].type === 'fa') {
                answer = document.getElementById(answerId).value
                response = {
                    "question": self.parent.activeStep.questions[self.selectedQuestion].question,
                    "answer": answer
                }
                localStorage.setItem(answerId, JSON.stringify(response))
            }

            else if (self.parent.activeStep.questions[self.selectedQuestion].type === 'mc' || self.parent.activeStep.questions[self.selectedQuestion].type === 'tf') {
                var options = document.getElementsByName(answerId)

                for (i = 0; i < options.length; i++) {
                    if (options[i].checked) {
                        response = {
                            "question": self.parent.activeStep.questions[self.selectedQuestion].question,
                            "answer": options[i].value
                        }
                        localStorage.setItem(answerId, JSON.stringify(response))
                    }
                }

            }
        }.bind(this)

        this.nextQuestion = function(e) {

            answerId = self.parent.selectedActivity.activity_ref + "_answer_" + self.parent.activeStepIndex + "_" + self.selectedQuestion
            self.saveAnswerToCache(answerId)

            if (self.selectedQuestion == self.parent.activeStep.questions.length - 1) {

                self.submitKnowledgeCheck();
                return
            } else {
                self.selectedQuestion += 1;
            }

            self.update()

            nextAnswerId = self.parent.selectedActivity.activity_ref + "_answer_" + self.parent.activeStepIndex + "_" + self.selectedQuestion
            self.loadAnswerFromCache(nextAnswerId);

        }.bind(this)

        this.prevQuestion = function(e) {

            answerId = self.parent.selectedActivity.activity_ref + "_answer_" + self.parent.activeStepIndex + "_" + self.selectedQuestion
            self.saveAnswerToCache(answerId)

            if (self.selectedQuestion == 0) {
                return
            } else {
                self.selectedQuestion -= 1;
            }

            self.update()

            prevAnswerId = self.parent.selectedActivity.activity_ref + "_answer_" + self.parent.activeStepIndex + "_" + self.selectedQuestion
            self.loadAnswerFromCache(prevAnswerId);

        }.bind(this)

        this.submitKnowledgeCheck = function() {

            cached_responses = []
            for (i = 0; i < window.localStorage.length; i++) {
                key = window.localStorage.key(i);
                if (key.startsWith(self.parent.selectedActivity.activity_ref)) {
                    cached_responses.push(JSON.parse(window.localStorage.getItem(key)));
                }
            }

            var kcData = {
                "response": {
                    "activity_ref": self.parent.selectedActivity.activity_ref,
                    "step": self.parent.activeStepIndex,
                    "responses": cached_responses
                }
            }

            postResponses(kcData);
        }.bind(this)

        function getQuestions(lesson_id) {
            self.questionsLoading = true;
            self.update();

            libGetQuestions(lesson_id).then(function(res) {
                self.questionsLoading = false;
                self.update({
                    questions: res['data']['questions'],
                });
            }).catch(function(error) {
                console.error('GET Questions Error:' + error);
                self.update({
                    questions: [],
                    questionsError: error
                });
            });
        }

        function getAnswers(act_ref) {
            self.responsesLoading = true;
            self.update();

            var profile = JSON.parse(localStorage.getItem('profile') || '{}');
            var user_id = profile.user_id || '';

            libGetAnswers(act_ref, user_id).then(function(res) {
                self.responsesLoading = false;
                self.update({
                    answers: res['data']['answers'],
                });
            }).catch(function(error) {
                console.error('GET Answers Error:' + error);
                self.update({
                    answers: [],
                    answersError: error
                });
            });
        }

        function postAnswers(data) {
            self.submitQuizLoading = true;
            self.update();

            libPostAnswers(data).then(function(res) {
                self.submitQuizLoading = false;
                self.selectedQuestion = -1;
                self.update({
                    answers: res['data']['answers'],
                    answersError: undefined
                });
            }).catch(function(error) {
                console.error('POST Answers Error:' + error);
                self.submitQuizLoading = false;
                self.update({
                    answersError: error
                });
            });
        }

        function getResponses(act_ref) {
            self.responsesLoading = true;
            self.update();

            libGetResponses(act_ref).then(function(res) {
                self.responsesLoading = false;
                self.update({
                    responses: res['data']['responses'],
                });
            }).catch(function(error) {
                console.error('GET Responses Error:' + error);
                self.update({
                    responses: [],
                    responsesError: error
                });
            });
        }

        function postResponses(data) {
            self.submitQuizLoading = true;
            self.update();

            libPostResponses(data).then(function(res) {
                self.submitQuizLoading = false;
                self.selectedQuestion = -1;
                self.update({
                    responses: res['data']['responses'],
                    responsesError: undefined
                });
            }).catch(function(error) {
                console.error('POST Responses Error:' + error);
                self.submitQuizLoading = false;
                self.update({
                    responsesError: error
                });
            });
        }
});
